<template>
  <h1 class="has-text-centered">
    <b>{{ $t("lockerDelivery.status") }}:</b>
    {{
      status === "waitingPackage"
        ? $t("lockerDelivery.waitingPackage")
        : status === "accessedByCourier"
        ? $t("lockerDelivery.accessedByCourier")
        : status === "deliveryConfirmed"
        ? $t("lockerDelivery.deliveryConfirmed")
        : status === "waitingPickUp"
        ? $t("lockerDelivery.waitingPickUp")
        : status === "accessedByClient"
        ? $t("lockerDelivery.accessedByClient")
        : status === "pickupConfirmed"
        ? $t("lockerDelivery.pickupConfirmed")
        : status === "cancelled"
        ? $t("lockerDelivery.cancelled")
        : "-"
    }}
    <br />
    <b>{{ $t("lockerDelivery.observations") }}:</b>
    {{ observations ? observations : "-" }}
  </h1>
</template>

<script>
export default {
  props: ["status", "observations"]
};
</script>

<style scoped>
h1 {
  margin-bottom: 1rem;
}
</style>
